export const chartOptions = [
  { value: "lagna", label: "Lagna (D1)" },
  { value: "navamsa", label: "Navamsa (D9)" },
  { value: "trimsamsa", label: "Trimsamsa (D30)" },
  { value: "drekkana", label: "Drekkana (D3)" },
  { value: "chaturthamsa", label: "Chaturthamsa (D4)" },
  { value: "dasamsa", label: "Dasamsa (D10)" },
  { value: "ashtamsa", label: "Ashtamsa (D8)" },
  { value: "dwadasamsa", label: "Dwadasamsa (D12)" },
  { value: "shodasamsa", label: "Shodasamsa (D16)" },
  { value: "hora", label: "Hora (D2)" },
  { value: "akshavedamsa", label: "Akshavedamsa (D45)" },
  { value: "shashtyamsa", label: "Shashtyamsa (D60)" },
  { value: "panchamsa", label: "Panchamsa (D5)" },
  { value: "khavedamsa", label: "Khavedamsa (D22)" },
  { value: "saptavimsamsa", label: "Saptavimsamsa (D27)" },
  { value: "shashtamsa", label: "Shashtamsa (D6)" },
  { value: "chaturvimsamsa", label: "Chaturvimsamsa (D24)" },
  { value: "saptamsa", label: "Saptamsa (D7)" },
  { value: "vimsamsa", label: "Vimsamsa (D20)" },
];

export const chartDNumbers = {
  lagna: "D1",
  navamsa: "D9",
  trimsamsa: "D30",
  drekkana: "D3",
  chaturthamsa: "D4",
  dasamsa: "D10",
  ashtamsa: "D8",
  dwadasamsa: "D12",
  shodasamsa: "D16",
  hora: "D2",
  akshavedamsa: "D45",
  shashtyamsa: "D60",
  panchamsa: "D5",
  khavedamsa: "D22",
  saptavimsamsa: "D27",
  shashtamsa: "D6",
  chaturvimsamsa: "D24",
  saptamsa: "D7",
  vimsamsa: "D20",
};

export const chartNames = {
  lagna: "Lagna",
  navamsa: "Navamsa",
  trimsamsa: "Trimsamsa",
  drekkana: "Drekkana",
  chaturthamsa: "Chaturthamsa",
  dasamsa: "Dasamsa",
  ashtamsa: "Ashtamsa",
  dwadasamsa: "Dwadasamsa",
  shodasamsa: "Shodasamsa",
  hora: "Hora",
  akshavedamsa: "Akshavedamsa",
  shashtyamsa: "Shashtyamsa",
  panchamsa: "Panchamsa",
  khavedamsa: "Khavedamsa",
  saptavimsamsa: "Saptavimsamsa",
  shashtamsa: "Shashtamsa",
  chaturvimsamsa: "Chaturvimsamsa",
  saptamsa: "Saptamsa",
  vimsamsa: "Vimsamsa",
};
